import styled from "styled-components"
import { Link } from "gatsby"

import { eq, when, maxWidth, minWidth } from "utils"

import Icon from "icons"
import CloudinaryImage from "components/cloudinary-image"

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 3.8rem);
  margin: 0 1.9rem 3rem;

  ${minWidth.tablet`
    width: 100%;
    margin: 0 auto 3rem;
    flex-direction: row;
    align-items: center;
    max-width: 58rem;
  `}

  ${minWidth.desktop`
    max-width: 72.5rem;
  `}
`

export const PersonWrapper = styled.div`
  margin-right: 4rem;
  display: flex;
  align-items: center;

  &:last-of-type {
    margin-right: 0;
  }

  ${when("hasReviewer")`
    ${minWidth.tablet`
      max-width: 50%;
    `}
  `}

  ${maxWidth.tablet`
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  `}
`

export const ImageWrapper = styled(Link)`
  width: 5.5rem;
  margin-right: 1.5rem;
  border: 2px solid #bbbbbb;
  border-radius: 50%;

  ${minWidth.tablet`
    display: block;
  `}
`

export const Image = styled(CloudinaryImage)`
  width: 100%;
  height: 0;
  padding-top: 100%;
  border-radius: 50%;
`

export const TextWrapper = styled.div`
  display: inline;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.4;

  ${minWidth.tablet`
    font-size: 1.5rem;
  `}
`

export const NameWrapper = styled.div`
  display: inline;

  ${minWidth.tablet`
    display: flex;
  `}
`

export const Name = styled.div``

export const NameLink = styled(Link)`
  color: #222;
  text-decoration: underline;

  ${minWidth.tablet`
    text-decoration: none;
  `};
`

export const Title = styled.div`
  color: #767676;
  order: ${({ isReviewer }) => (isReviewer ? 0 : 1)};

  ${minWidth.tablet`
    order: 0;
  `}
`

export const TooltipTitle = styled(Title)`
  margin-bottom: 0.5rem;
  font-weight: 500;
`
export const Tooltip = styled.div`
  position: absolute;
  z-index: 1200;
  top: calc(100% + 1.5rem);
  width: 34.6rem;
  padding: 2rem 3rem;
  border-radius: 0.6rem;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.33;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.text.primary};
  box-shadow: 0 1px 25px 0 rgba(145, 145, 145, 0.35);
  opacity: 0;
  transition: opacity 0.15s linear;
  pointer-events: none;

  ${maxWidth.mobile`
    left: calc(100% - 35rem);
    width: 32rem;
  `}

  ${eq("tooltipActive", true)`
    opacity: 1;
    pointer-events: unset;
  `}
`
export const IconWrapper = styled.div`
  position: relative;
  top: 0.4rem;
  margin-left: 1rem;
  display: inline-block;
  cursor: pointer;

  &:hover + ${Tooltip}, &:active + ${Tooltip} {
    opacity: 1;
  }
`
export const InfoIconEditor = styled(Icon)`
  path {
    fill: ${({ theme }) => theme.article.color};
  }
`
export const InfoIconReviewer = styled(Icon)`
  path {
    fill: #222;
  }
`

export const DateWrapper = styled.div`
  color: #767676;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  order: 2;
`

export const Type = styled.span`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
`

export const TypeWrapper = styled.span`
  line-height: 1.7rem;
  padding-bottom: 0.5rem;
`

export const ReviewerWrapper = styled(TypeWrapper)`
  display: block;
`
export const MobileWrapper = styled.div`
  display: block;

  ${minWidth.tablet`
    display: none
  `}
`
export const DesktopWrapper = styled.div`
  display: none;

  ${minWidth.tablet`
    display: block
  `}
`

export const NameToggle = styled.a`
  text-decoration: underline;
  color: #222;
  cursor: pointer;
`

export const TooltipName = styled.div`
  font-weight: 500;
  color: #222;
`

export const Background = styled.div`
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;

  ${eq("tooltipActive", false)`
    display: none;
  `}
`
export const TooltipReadMore = styled.a`
  font-weight: 500;
  color: #222;
  cursor: pointer;
  text-decoration: underline;
`

export const TooltipDesc = styled.div`
  margin-bottom: 0.5rem;
`
